import styled from 'styled-components';

export const MainWrapper = styled.div<{ isNewPd: boolean }>`
  margin-top: 1rem;
  width: ${({ isNewPd }) => (isNewPd ? '100%' : '62%')};
`;

export const BannerCarouselWrapper = styled.div``;

export const SliderWrapper = styled.div`
  position: relative;
`;
